export const AUTH = 'authenticate'
export const USER_DATA = 'account'
export const ADD_PASSWORD = 'account/change-password-key'
export const EMAIL_RESET = 'account/reset-password/init'
export const FINISH_RESET_PASSWORD = 'account/reset-password/finish'
export const CUSTOMER_ORDER = '_search/customer-order'
export const CUSTOMER_ORDER_ACTIONS = 'customer-order/actions'
export const PARTNER_CUSTOMER_ORDER_ACTIONS = 'partner/customer-order/actions'
export const ORDERS_EFFECTIVE_STATUS = 'customer-order/effective-status'
export const DOWNLOAD = 'customer-order/download'
export const DELIVERED = '_search/customer-order/delivered'
export const EDD_ORDERS = '_search/customer-order/edd-orders'
export const INCIDENT_REASONS = 'reason-moments/type'
export const UPLOAD_IMAGE = 'proof-of-conditions'
export const UPLOAD_PROOF_DELIVERIES = 'proof-of-deliveries'
export const VEHICLES = 'vehicles'
export const VEHICLES_ACTIVE = 'vehicles/operator'
export const PARTNERS = 'operators'
export const DRIVERS = 'users/operator'
export const ADD_DRIVERS = 'users/vehicle'
export const USERS_AUTHORITIES = 'users/authorities'
export const USERS = 'users'
export const ACTIVE_MESSAGES = 'comments/active'
export const MESSAGES = 'comments'
export const STORES = 'stores'
export const SCHEDULING_PERIODS_ACTIVE = 'scheduling-periods/active'
export const REPORT_REASONS = 'report-reasons'
export const FILTER_STORES = 'stores'
export const ORDER_EDF_PARTNER_STATES = 'reference-data/edf-for-partner/effective-status'
export const EDF_ORDERS = '_search/edf/orders-for-partner'
export const EDF_DELIVERY_DOWNLOAD = 'edf/orders-for-partner/download'
export const LIST_PODS = 'proof-of-deliveries/by/order'
export const INACTIVE_PODS = 'proof-of-deliveries/inactivate'



// WEBPACK FOOTER //
// ./src/repository/endpoints.js